<template>
  <div class="download-file" v-if="dialogVisible">
    <div class="download-content" v-show="!showHtmlDownload">
      <div class="header">
        <div class="title">{{ language.fileDownload }}</div>
        <div class="headerbtn" @click="closeDownload">
          <!-- <img src="close_cusPos" alt=""> -->
          <!-- <img src="@imgs/close_cusPos.png" alt="" /> -->
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="body">
        <div class="download-group">
          <div class="pdf format" v-if="format.includes('pdf')">
            <div class="outer">
              <img src="@imgs/pdf-download.png" alt="" />
            </div>
            <el-button class="download-btn" size="mini" :disabled="lock1" @click="downloadFile('pdf')">{{ language.download }}</el-button>
          </div>
          <div class="zip format" v-if="format.includes('zip')">
            <div class="outer">
              <img src="@imgs/html-download.png" alt="" />
            </div>
            <el-button v-if="!hasArticle" class="download-btn" size="mini" @click="downloadFile(isPaper ? 'html' : 'zip')">{{ language.download }}</el-button>
            <el-button v-else class="download-btn" size="mini" @click="showHtmlDownload = true">{{ language.download }}</el-button>
          </div>
          <div class="epub format" v-if="format.includes('epub')">
            <div class="outer">
              <img src="@imgs/epub-download.png" alt="" />
            </div>
            <el-button class="download-btn" size="mini" :disabled="lock3" @click="downloadFile('epub')">{{ language.download }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="download-content html" v-if="showHtmlDownload">
      <div class="header">
        <div class="title">{{ language.fileDownload }}</div>
        <div class="headerbtn" @click="closeDownload">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="body">
        <div class="download-group">
          <div class="zip format" v-if="format.includes('zip')">
            <div class="outer">
              <img src="@imgs/html-download.png" alt="" />
            </div>
            <p>您的作品中包含文章，合成离线语音朗读需要一段时间，请选择下载方式。</p>
            <el-button class="download-btn" size="large" @click="downloadFile(isPaper ? 'html' : 'zip')">立刻下载不含语音朗读的离线包</el-button>
            <el-button class="download-btn" size="large" @click="generateDownloadLink(isPaper ? 'html' : 'zip')">生成含朗读音频的离线包下载链接</el-button>
            <div class="tip">提示：生成下载链接后，系统将在后台生成离线数据，预计10分钟后可使用链接地址下载，下载完成后地址将失效。</div>
            <div class="tip">下载链接：{{ downloadLink }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@api/getBook.js'
export default {
  name: 'download',
  data() {
    return {
      dialogVisible: false,
      // loading: false,
      lock1: false,
      lock3: false,
      timer1: null,
      timer2: null,
      timer3: null,
      showHtmlDownload: false,
      downloadLink: ''
    }
  },
  props: {
    format: {
      type: String,
      default: ''
    },
    isPaper: {
      type: Boolean,
      default: false
    },
    hasArticle: {
      type: Boolean,
      default: false
    },
    id: [String, Number]
  },
  watch: {
    id() {
      this.showHtmlDownload = false
    }
  },
  methods: {
    closeDownload() {
      //关闭弹窗
      this.dialogVisible = false
    },
    downloadFile(payload) {
      //发送接口拿链接
      let a = document.createElement('a')
      // a.href = window.PROJECT_CONFIG.BASE_URL2 + '/ebook/downLoadEbook?id=' + this.id + '&fileFormat=' + payload
      a.href = this.isPaper
        ? `${window.PROJECT_CONFIG.BASE_URL}/cloudR/epaper/download?id=${this.id}&format=${payload}`
        : `${window.PROJECT_CONFIG.BASE_URL}/cloudR/ebook/downLoad?id=${this.id}&fileFormat=${payload}`
      // a.target = '_blank'
      a.click()
      a.style.display = 'none'
      if (payload === 'pdf') {
        this.lock1 = true
        this.timer1 = null
        this.timer1 = setTimeout(() => {
          this.lock1 = false
        }, 2000)
      } else if (payload === 'epub') {
        this.lock3 = true
        this.timer3 = null
        this.timer3 = setTimeout(() => {
          this.lock3 = false
        }, 2000)
      } else if (payload === 'zip' || payload === 'html') {
        this.timer2 = null
        const loading = this.$loading({
          lock: true,
          customClass: 'create-loading-download',
          text: '正在压缩，请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.timer2 = setTimeout(() => {
          loading.close()
        }, 5000)
      }
    },
    generateDownloadLink() {
      api.generateHtmlDownLink({ id: this.id, module: this.isPaper ? 'epaper' : 'ebook' }).then((res) => {
        if (res.data.status === 0) {
          this.downloadLink = res.data.data
        }
      })
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    language() {
      return this.$store.state.config.languageOptions[this.currentLang]
    }
  },
  destroyed() {
    clearTimeout(this.timer1)
    clearTimeout(this.timer2)
    clearTimeout(this.timer3)
    this.showHtmlDownload = false
  }
}
</script>

<style lang="scss">
.download-file {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .download-content {
    width: 400px;
    height: 240px;
    background-color: #fff;
  }
  .header {
    background: #f4f4f4;
    color: #000000;
    padding: 0;
    height: 42px;
    position: relative;
    .title {
      font-size: 14px;
      line-height: 42px;
      text-align: center;
    }
    .headerbtn {
      position: absolute;
      right: 13px;
      top: 13px;
      width: 13px;
      height: 13px;
      cursor: pointer;
      i {
        width: 100%;
        color: #979797;
        line-height: 13px;
        vertical-align: top;
      }
    }
  }
  .body {
    padding: 30px 55px;
    .download-group {
      display: -webkit-flex;
      display: flex;
      justify-content: space-around;
      .outer {
        width: 70px;
        height: 70px;
        border: 1px dashed #a9a9a9;
        img {
          width: 100%;
        }
      }
      .download-btn {
        width: 80px;
        color: #fff;
        background: #df5813;
        margin-top: 17px;
        border: none;
      }
      .format {
        width: 80px;
        display: -webkit-flex;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }
  .html {
    width: 650px;
    height: 480px;
    .download-group {
      width: 100%;
      .zip {
        width: 100%;
        flex-direction: column;
        align-items: center;
        .el-button--large {
          display: block;
          width: 230px;
          margin: 10px 0;
          padding-left: 0;
          padding-right: 0;
        }
        .tip {
          margin-top: 10px;
          color: #9b9aa7;
          width: 100%;
          word-wrap: break-word;
          cursor: text;
          user-select: text;
        }
      }
    }
  }
}
.create-loading-download {
  .el-loading-spinner {
    .el-loading-text {
      color: #fff;
      font-size: 14px;
    }
    .el-icon-loading {
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
